export const TIMELINE_COPY = {
	ADDED: 'Added',
	ADDITIONS: 'Additions',
	DELETED: 'Deleted',
	DELETIONS: 'Deletions',
	HIDE_SYSTEM_CHANGES: 'Hide System Changes',
	INCLUDE_SYSTEM_CHANGES: 'Include System Changes',
	MODIFICATIONS: 'Modifications',
	MODIFIED: 'Modified',
	NEGATIVE: 'negative',
	NO_CHANGES_MADE_DURING_TIMEFRAME: 'No changes made during this timeframe',
	PARDOT_FIELD: 'Pardot Field',
	PARDOT_OBJECT: 'Pardot Object',
	POSITIVE: 'positive',
	SFDC_APEX_CLASS: 'Salesforce Apex Class',
	SFDC_APEX_TRIGGER: 'Salesforce Apex Trigger',
	SFDC_ENTITY: 'Salesforce Object',
	SFDC_FIELD: 'Salesforce Field',
	SFDC_FLOW: 'Salesforce Flow',
	SFDC_PICKLIST_VALUE: 'Salesforce Picklist Value',
	SFDC_PROCESS_BUILDER: 'Salesforce Process Builder',
	SFDC_REPORT: 'Salesforce Report',
	SFDC_VALIDATION_RULE: 'Salesforce Validation Rule',
	SFDC_WORKFLOW_RULE: 'Salesforce Workflow Rule',
	STATISTICS_ADDITIONS: (additions: number): string =>
		`${additions.toLocaleString()} ${additions === 1 ? 'addition' : 'additions'}`,
	STATISTICS_ADMIN_COUNT: (adminCount: number): string =>
		`${adminCount.toLocaleString()} ${adminCount === 1 ? 'admin' : 'admins'}`,
	STATISTICS_AUTOMATION_COUNT: (automationCount: number): string =>
		`${automationCount.toLocaleString()} ${automationCount === 1 ? 'piece' : 'pieces'} of automation`,
	STATISTICS_CHANGE_COUNT: (changeCount: number): string =>
		`${changeCount.toLocaleString()} ${changeCount === 1 ? 'change' : 'changes'}`,
	STATISTICS_COMMA: ', ',
	STATISTICS_DELETIONS: (deletions: number): string =>
		`${deletions.toLocaleString()} ${deletions === 1 ? 'deletion' : 'deletions'}`,
	STATISTICS_EXCLUDING: 'Excluding system changes, ',
	STATISTICS_FIELD_COUNT: (fieldCount: number): string =>
		`${fieldCount.toLocaleString()} ${fieldCount === 1 ? 'field' : 'fields'}`,
	STATISTICS_HAS_MADE: ' has made ',
	STATISTICS_HAVE_MADE: ' have made ',
	STATISTICS_MODIFICATIONS: (modifications: number): string =>
		`${modifications.toLocaleString()} ${modifications === 1 ? 'modification' : 'modifications'}`,
	STATISTICS_OBJECT_COUNT: (objectCount: number): string =>
		`${objectCount.toLocaleString()} ${objectCount === 1 ? 'object' : 'objects'}`,
	STATISTICS_ORGANIZATION: (organization: string): string => `${organization}`,
	STATISTICS_PERIOD: '. ',
	STATISTICS_THIS_INCLUDES: 'This includes ',
	STATISTICS_TO: ' to ',
	STATISTICS_WITH: ' with '
};
